import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class CacheService {

  itemsToDisplayFiltered: Array<any>;
  typeFiltersChosen: Array<any>;
  userFiltersChosen: Array<any>;
  dateFilterChosen: number;
  orgUsersFiltersChosen: Array<any>;
  orgFiltersChosen: any[];
  currentUserSavedPlaces: Array<any>;
  currentUserSavedWaterSources: Array<any>;
  userFilterList: {};
  orgFilterList: {};
  itemsToDisplay: any;
  resultsString: string;
  testListCached = false;
  locationListCached = false;
  options: any[];
  locationsToDisplay: Array<any>;
  userSavedPlaces: any[];
  userTests;
  userOrgData;
  testFilters: Array<any>;
  filteredOptions: Observable<any[]>;
  markers: Array<any>;

  constructor() {
  }

  clearCache() {
    this.itemsToDisplayFiltered = [];
    this.typeFiltersChosen = [];
    this.userFiltersChosen = [];
    this.dateFilterChosen = undefined;
    this.orgUsersFiltersChosen = [];
    this.orgFiltersChosen = [];
    this.currentUserSavedPlaces = [];
    this.currentUserSavedWaterSources = [];
    this.userFilterList = {};
    this.orgFilterList = {};
    this.itemsToDisplay = [];
    this.resultsString = '';
    this.testListCached = false;
    this.locationListCached = false;
    this.options = [];
    this.locationsToDisplay = [];
    this.userSavedPlaces = [];
    this.userTests = [];
    this.userOrgData = [];
    this.testFilters = [];
    this.filteredOptions = undefined;
    this.markers = [];
  }
}
